import React from 'react';
import './sidebar.css';

function Sidebar({ isOpen, onClose, activeSection, onSelectSection }) {
  const sections = [
    { id: 'avisos', label: 'Avisos', icon: '📢' },
    { id: 'cursos', label: 'Mis Cursos', icon: '📚' },
    { id: 'perfil', label: 'Mi Perfil', icon: '👤' }
  ];

  return (
    <>
      {/* Overlay para cerrar el sidebar */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      
      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>Mi Plataforma</h2>
          <button className="sidebar-close" onClick={onClose}>✕</button>
        </div>
        
        <nav className="sidebar-nav">
          {sections.map((section) => (
            <button
              key={section.id}
              className={`sidebar-item ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => {
                onSelectSection(section.id);
                onClose();
              }}
            >
              <span className="sidebar-icon">{section.icon}</span>
              <span className="sidebar-label">{section.label}</span>
            </button>
          ))}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
